var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 21 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5008 0H0.391285C0.160924 0 0 0.160923 0 0.391284V11.6087C0 11.8391 0.160924 12 0.391285 12H20.5008C20.7312 12 20.8921 11.8391 20.8921 11.6087V0.391284C20.8921 0.20312 20.7425 0 20.5008 0ZM20.1096 9.21413V11.2174H18.1087C18.2906 10.1719 19.0966 9.36509 20.1096 9.21413ZM2.78582 11.1859H0.78257V9.18504C1.82809 9.36704 2.63491 10.173 2.78582 11.1859ZM0.78257 2.78582V0.782621H2.7835C2.60151 1.82814 1.7955 2.63497 0.78257 2.78582ZM20.1096 2.7835C19.064 2.60151 18.2573 1.79555 18.1063 0.782621H20.1096V2.7835ZM20.141 3.60215V8.42946C18.6759 8.61705 17.5058 9.78726 17.3214 11.2488H3.60585C3.43095 9.76912 2.25453 8.58354 0.78257 8.39785V3.602C2.24764 3.41435 3.41774 2.2442 3.6021 0.782621H17.3215C17.5092 2.24769 18.6794 3.41779 20.141 3.60215Z",
    fill: "#3D0137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.446 1.96503C8.21252 1.96503 6.39539 3.78211 6.39539 6.01567C6.39539 8.24917 8.21247 10.0663 10.446 10.0663C12.6796 10.0663 14.4967 8.23684 14.4967 5.98822C14.4967 4.90293 14.0735 3.8882 13.3051 3.13097C12.5421 2.37913 11.5267 1.96503 10.446 1.96503ZM10.446 9.18167C8.68517 9.18167 7.25258 7.74908 7.25258 5.98822C7.25258 4.22736 8.68517 2.79478 10.446 2.79478C12.2069 2.79478 13.6395 4.22736 13.6395 5.98822C13.6395 7.74908 12.2069 9.18167 10.446 9.18167Z",
    fill: "#3D0137"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashIcon);
export default __webpack_public_path__ + "static/media/Cash_icon.70c8e7a651a35af4a964f4d0271263dc.svg";
export { ForwardRef as ReactComponent };